import { render, staticRenderFns } from "./procedures.vue?vue&type=template&id=eb36f240"
import script from "./procedures.vue?vue&type=script&lang=js"
export * from "./procedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports